import { render, staticRenderFns } from "./EpisodesMainContent.vue?vue&type=template&id=52b77c7c"
import script from "./EpisodesMainContent.vue?vue&type=script&lang=js"
export * from "./EpisodesMainContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports